import { render, staticRenderFns } from "./moments_apply_detail.vue?vue&type=template&id=08cfd346&scoped=true"
import script from "./moments_apply_detail.vue?vue&type=script&lang=js"
export * from "./moments_apply_detail.vue?vue&type=script&lang=js"
import style0 from "./moments_apply_detail.vue?vue&type=style&index=0&id=08cfd346&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08cfd346",
  null
  
)

export default component.exports